import {Card} from 'platform/components';
import {Grid, type Integer} from 'platform/foundation';

import {CustomerInsightsSectionSkeleton} from './CustomerInsightsSectionSkeleton';

const SKELETON_CARD_KEYS = ['first', 'second', 'third', 'fourth'] as const;

interface CustomerInsightsSkeletonRowProps {
  skeletonHeight: Integer;
}

export function CustomerInsightsSkeletonRow(props: CustomerInsightsSkeletonRowProps) {
  return (
    <section>
      <Grid columns={1} spacing={3}>
        {SKELETON_CARD_KEYS.map((key) => (
          <Card key={key} variant="inlineWhite">
            <CustomerInsightsSectionSkeleton
              skeletonHeight={props.skeletonHeight}
              skeletonVariant="record"
            />
          </Card>
        ))}
      </Grid>
    </section>
  );
}
